import script from "./SpecialDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialDetail.vue?vue&type=script&setup=true&lang=js"

import "./SpecialDetail.vue?vue&type=style&index=0&id=27f3b3ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f3b3ba"]])

export default __exports__